export const mainLeadDates = [
  "Site identification post discussion with Ops Date",
  "Site Feasibility Date",
  "Submission of final Layout & Capex budget Date",
  "CF discussion with BD & RM Date",
  "SRP sent to Business Finance Date",
  "CF discussion with BD, RM, NBDH & NOH Date",
  "CF discussion with COO Date",
  "SRP sent to COO Date",
  "SRP approved by COO Date",
  "CF discussion with CFO Date",
  "CF creation date",
  "Approver 1 date",
  "Approver 2 date",
  "Approver 3 date",
  "Approver 4 date",
  "Approver 5 date",
  "Approver 6 date",
  "CF Approval Date",
  "LOI Signing Date",
  "Sec Deposit Payment Tranche1 Date",
  "Layout Design Date",
  "Possession Date",
  "Title Diligence Date",
  "FSSAI License receipt Date",
  "Registration Date",
  "Handover to operations Date",
  "Store Opened Date",
];

export const stageGatesDates = [
  "Initial Estimated",
  "Revised Projected Date",
  "Actual Date",
];
